<div>
    <span class="status-title" *ngFor="let status of statusList;"> 
        <i class="fa fa-circle" aria-hidden="true" [ngClass]="status.icoColor"></i>
        {{ status.title }}
    </span>
</div>